/**
 * Given a date, determine how long ago that date was set.
 * @param {int} number - number of min, months, years, etc.
 * @param {string} type - type of number (year, month, day, hour, minute).
 *
 * @returns {string} - s or empty string + ago.
 */
export default function timeAgoFormat(number, type) {
  const plurality = 1 < number ? 's' : '';
  return `${number} ${type}${plurality} ago`;
}
